import merge from 'lodash/merge';
import BackboneElement from './BackboneElement';
import BN_Asam4AssessmentMeasure from './BN_Asam4AssessmentMeasure';

export default class BN_Asam4AssessmentSubdimension extends BackboneElement {
    static __className = 'BN_Asam4AssessmentSubdimension';

    __objectStructure = {
        id: String,
        name: String,
        text: String,
        level: String,
        clinicalJustification: String,
        measure: [BN_Asam4AssessmentMeasure],
        riskRating: String,
        dimensionalDriver: Boolean,
    };

    constructor(constructJson, className = 'BN_Asam4AssessmentSubdimension') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
